import { Flex, Form, Space, Table, Radio, Badge } from 'antd'
import React, { useEffect, useState } from 'react'
import classes from './report.module.css'; 
import FormItemInput from '../../cpn/FormItemInput';
import ClientSelect from '../../system/client/ClientSelect';
import dayjs from 'dayjs';
import Icon from '../../cpn/Icon';
import ReportCheck from './ReportCheck';
import ReportEdit from './ReportEdit';
import ClientCheck from '../../system/client/ClientCheck';
import StateTag from '../../cpn/StateTag';
function ReportListSubmitted(props) {
    const [form] = Form.useForm();   
    const [list, setList] = useState([]);
    const [query, setQuery] = useState({
        "dsbzd_state": '',
        "dsbzd_kh_id": '',
    });
    useEffect(() => {
        let arr = props.list.filter((item) => ((item.dsbzd_state === '2' || item.dsbzd_state === '3' || item.dsbzd_state === '4' || item.dsbzd_state === '5' || item.dsbzd_state === '6') && item.dsbzd_uid === props.yh_id));
        if(query.dsbzd_state){
            if(query.dsbzd_state === '5'){
                arr = arr.filter((item) => item.dsbzd_state === '5' || item.dsbzd_state === '6');
              }else{
                arr = arr.filter((item) => item.dsbzd_state === query.dsbzd_state);
            }
        }
        const unread = arr.filter(item => item.dsbzd_state === '5');
        const read = arr.filter(item => item.dsbzd_state === '2' || item.dsbzd_state === '3' || item.dsbzd_state === '4' ||  item.dsbzd_state === '6');
        read.sort((a, b) => new Date(b.dsbzd_state_time) - new Date(a.dsbzd_state_time));
        const sortedArr = [...unread, ...read];
        setList(sortedArr);
    }, [props.list, props.yh_id, props.yh_qx, query.dsbzd_state]);
    const columnsTable = [      
        {
            key: 'dsbzd_name',
            dataIndex: 'dsbzd_name',
            title: "团队名称",         
            render: (_, record) => {
                if(record.dsbzd_state === '4'){
                    return <ReportEdit 
                                dsbzd_id={record.dsbzd_id} 
                                commonList={props.commonList}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                dsbzd_name={record.dsbzd_name}
                                spjdList={props.spjdList}
                            />
                }else{
                    return  <ReportCheck 
                                dsbzd_id={record.dsbzd_id} 
                                dsbzd_name={record.dsbzd_name} 
                                yh_id={props.yh_id}  
                                yh_name={props.yh_name} 
                                qy_id={props.qy_id} 
                                qy_name={props.qy_name} 
                                spjdList={props.spjdList} 
                                dsbzd_ctime={record.dsbzd_ctime} 
                                dsbzd_state={record.dsbzd_state}
                                dsbzd_state_time={record.dsbzd_state_time} 
                                dsbzd_uid={record.dsbzd_uid}
                                listType='submitted'
                            />
                }
            }
        },
        {
            key: 'dsbzd_date',
            dataIndex: 'dsbzd_date',
            title: "开始日期",
            width: "6%",            
        },
        {
            key: 'dsbzd_date_end',
            dataIndex: 'dsbzd_date_end',
            title: "结束日期",
            width: "6%",
        },
        {
            key: 'dsbzd_date_end',
            dataIndex: 'dsbzd_date_end',
            title: "天数",
            width: "3%",
            render: (_, record) => <>{dayjs(record.dsbzd_date_end).diff(dayjs(record.dsbzd_date), 'day') + 1}</>,
        },
      
        {
            key: 'dsbzd_kh_name',
            dataIndex: 'dsbzd_kh_name',
            title: "客户",
            width: "8%",
            render: (text, record) =>   <ClientCheck 
                                            kh_id={record.dsbzd_kh_id} 
                                            kh_name={record.dsbzd_kh_name} 
                                            qy_id={props.qy_id} 
                                            qy_name={props.qy_name} 
                                            yh_id={props.yh_id} 
                                            yh_name={props.yh_name} 
                                            spjdList={props.spjdList}
                                        />

        },
        {
            key: 'dsbzd_khlxr_name',
            dataIndex: 'dsbzd_khlxr_name',
            title: "对接人",
            width: "8%",
        },      
        {
            key: 'dsbzd_bm_name',
            dataIndex: 'dsbzd_bm_name',
            title: "部门",
            width: "6%",
        },             
        {
            key: 'dsbzd_jd_name',   
            dataIndex: 'dsbzd_jd_name',
            title: "计调",
            width: "6%",
        },               
        {
            key: 'dsbzd_state_time',
            dataIndex: 'dsbzd_state_time',
            title: "审批时间",
            width: '10%',            
        },
        {
            key: 'dsbzd_state',
            dataIndex: 'dsbzd_state',
            title: "状态",
            width: "10%",
            render: (text, record) => <StateTag state={record.dsbzd_state} />
        },
        {
            key: 'dsbzd_id',
            dataIndex: 'dsbzd_id',
            title: "编号",
            width: "4%",            
        },     
    ];
    return (
        <>   
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_report_list_submitted'
                    form={form}
                    initialValues={{                        
                        dsbzd_state: query.dsbzd_state ? query.dsbzd_state : '',
                        dsbzd_kh_id: query.dsbzd_kh_id ? query.dsbzd_kh_id : '',                        
                        dsbzd_content: query.dsbzd_content ? query.dsbzd_content : '',
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            dsbzd_state: values.dsbzd_state ? values.dsbzd_state : '',
                            dsbzd_kh_id: values.dsbzd_kh_id ? values.dsbzd_kh_id : '',
                            dsbzd_content: values.dsbzd_content ? values.dsbzd_content : '',
                        };
                        
                        localStorage.setItem('jtg-caiwu_reportList_dsbzd_state', JSON.stringify(serializedValues.dsbzd_state));
                        localStorage.setItem('jtg-caiwu_reportList_dsbzd_kh_id', JSON.stringify(serializedValues.dsbzd_kh_id));
                        localStorage.setItem('jtg-caiwu_reportList_dsbzd_content', JSON.stringify(serializedValues.dsbzd_content));
                        setQuery(prev => ({ 
                            ...prev, 
                            dsbzd_state: serializedValues.dsbzd_state, 
                            dsbzd_kh_id: serializedValues.dsbzd_kh_id, 
                            dsbzd_content: serializedValues.dsbzd_content, 
                        }));
                    }}
                >
                    <Form.Item 
                        name='dsbzd_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle
                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    dsbzd_state: e.target.value,                                     
                                }));
                                localStorage.setItem('jtg-caiwu_reportList_dsbzd_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge count={props.reportRejectedNum} style={{zIndex:'9999'}}>
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Badge count={props.reportEndNeedReadNum} style={{zIndex:'9999'}}>
                                <Radio value='5' >已结束</Radio>
                            </Badge>
                        </Radio.Group>        
                    </Form.Item>
                    <ClientSelect                       
                        formStyle={{ marginBottom: "0", marginLeft: "10px" }}
                        onClear={() => { setQuery(prev => ({ ...prev, dsbzd_kf_id: '' })) }}
                        placeholder='客户'
                        qy_id={props.qy_id}
                        style={{ width: "100px" }}
                        name='dsbzd_dspt_id'
                        onChange={(e) => {}}
                        yh_id={props.yh_id}
                    />  
                    <FormItemInput
                        placeholder='备注关键字'
                        onChange={(e) => {}}
                        onClear={() => { setQuery(prev => ({ ...prev, dsbzd_content: '' })) }}
                        formStyle={{ marginBottom: "0" }}
                        style={{ width: "130px" }}
                        name='dsbzd_content'
                    />
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_reportList_dsbzd_content', JSON.stringify(''))
                                    localStorage.setItem('jtg-caiwu_reportList_dsbzd_danhao', JSON.stringify(''))
                                    localStorage.setItem('jtg-caiwu_reportList_dsbzd_dspt_id', JSON.stringify(''))
                                    localStorage.setItem('jtg-caiwu_reportList_dsbzd_ctime', JSON.stringify(''))
                                    localStorage.setItem('jtg-caiwu_reportList_dsbzd_month', JSON.stringify(''))
                                    localStorage.setItem('jtg-caiwu_reportList_dsbzdsh_uid', JSON.stringify(''))
                                    localStorage.setItem('jtg-caiwu_reportList_dsbzd_uid', JSON.stringify(''))
                                    localStorage.setItem('jtg-caiwu_reportList_dsbzd_kf_id', JSON.stringify(''))
                                    localStorage.setItem('jtg-caiwu_reportList_dsbzd_jd_id', JSON.stringify(''))
                                    localStorage.setItem('jtg-caiwu_reportList_dsbzd_zb_id', JSON.stringify(''))
                                    localStorage.setItem('jtg-caiwu_reportList_dsbzd_state', JSON.stringify(''))
                                    setQuery({
                                        "dsbzd_content": '',
                                        "dsbzd_danhao": '',
                                        "dsbzd_dscp_id": '',
                                        "dsbzd_dspt_id": '',
                                        "dsbzd_jd_id": '',
                                        "dsbzd_kf_id": '',
                                        "dsbzd_qy_id": props.qy_id,
                                        "dsbzd_zb_id": '',
                                        "dsbzd_ctime": '',
                                        "dsbzd_month": '',
                                        "dsbzdsh_uid": '',
                                        "dsbzd_uid": '',
                                        "dsbzd_state": '',
                                    })
                                    form.setFieldsValue({
                                        dsbzd_month: null,
                                        dsbzd_ctime: null,
                                        dsbzd_dspt_id: null,
                                        dsbzd_kf_id: null,
                                        dsbzd_jd_id: null,
                                        dsbzd_zb_id: null,
                                        dsbzd_uid: null,
                                        dsbzdsh_uid: null,
                                        dsbzd_content: null,
                                        dsbzd_danhao: null,
                                        dsbzd_state: '',
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>  
            </Flex>
            <Table               
                dataSource={list}
                columns={columnsTable}
                className={classes.customTable}
                size='small'
                bordered
                rowKey="dsbzd_id"
                pagination={{
                    showTotal: (total) => `共${total}条`,
                    pageSize: 50,
                    placement: 'bottomCenter',
                    showSizeChanger: true,
                }}
                locale={{
                    emptyText: '暂无团队报账单' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default ReportListSubmitted